/*
* @Author: Jsonzhang0215
* @Date:   2018-03-31 10:25:05
* @Last Modified by:   Jsonzhang0215
* @Last Modified time: 2018-04-01 21:02:19
*/
import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user'
// import app from './modules/app';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        //
    },
    mutations: {
        //
    },
    actions: {

    },
    modules: {
        user
        // app
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js